/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DeleteProposalCommand,
  ErrorResult,
  GetProposalsForOverviewQuery,
  NotFoundErrorResult,
  Result,
  ResultOfIEnumerableOfProposalOverviewViewModel,
  ValidationErrorResult,
} from '../models';
import {
    DeleteProposalCommandFromJSON,
    DeleteProposalCommandToJSON,
    ErrorResultFromJSON,
    ErrorResultToJSON,
    GetProposalsForOverviewQueryFromJSON,
    GetProposalsForOverviewQueryToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfIEnumerableOfProposalOverviewViewModelFromJSON,
    ResultOfIEnumerableOfProposalOverviewViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface ProposalsOverviewsDeleteProposalRequest {
    deleteProposalCommand: DeleteProposalCommand;
}

export interface ProposalsOverviewsSearchRequest {
    query: GetProposalsForOverviewQuery;
}

/**
 * 
 */
export class ProposalsOverviewsApi extends runtime.BaseAPI {

    /**
     * Delete a proposal
     */
    async proposalsOverviewsDeleteProposalRaw(requestParameters: ProposalsOverviewsDeleteProposalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.deleteProposalCommand === null || requestParameters.deleteProposalCommand === undefined) {
            throw new runtime.RequiredError('deleteProposalCommand','Required parameter requestParameters.deleteProposalCommand was null or undefined when calling proposalsOverviewsDeleteProposal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/proposal-overview`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteProposalCommandToJSON(requestParameters.deleteProposalCommand),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Delete a proposal
     */
    async proposalsOverviewsDeleteProposal(requestParameters: ProposalsOverviewsDeleteProposalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.proposalsOverviewsDeleteProposalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for proposals by the Provided search criteria.
     */
    async proposalsOverviewsSearchRaw(requestParameters: ProposalsOverviewsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfIEnumerableOfProposalOverviewViewModel>> {
        if (requestParameters.query === null || requestParameters.query === undefined) {
            throw new runtime.RequiredError('query','Required parameter requestParameters.query was null or undefined when calling proposalsOverviewsSearch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/proposal-overview/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetProposalsForOverviewQueryToJSON(requestParameters.query),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfIEnumerableOfProposalOverviewViewModelFromJSON(jsonValue));
    }

    /**
     * Search for proposals by the Provided search criteria.
     */
    async proposalsOverviewsSearch(requestParameters: ProposalsOverviewsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfIEnumerableOfProposalOverviewViewModel> {
        const response = await this.proposalsOverviewsSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
